import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 4px;
`;
const ErrorMessage = styled.span`
    font-family: 'IBM Plex Sans';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) =>
        theme.components.lyt_input?.border?.error || '#C8322A'};
`;

/**
 * Component to display form field errors
 * Supports both single error strings and arrays of multiple errors
 *
 * @param {Object} props - Component props
 * @param {string|Array<string>} props.error - Error message(s) to display
 * @param {string} [props.className] - Additional CSS class names
 * @returns {JSX.Element|null} Error display component or null if no errors
 */
const FormErrorDisplay = ({ error = null, className = null }) => {
    if (!error) return null;

    // Handle both single error strings and arrays of errors
    const errors = Array.isArray(error) ? error : [error];
    return (
        <ErrorContainer className={className}>
            {errors.map((errorMsg, index) => (
                <ErrorMessage key={index}>{errorMsg}</ErrorMessage>
            ))}
        </ErrorContainer>
    );
};
FormErrorDisplay.propTypes = {
    /** Error message(s) to display - can be string or array of strings */
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]),
    /** Additional CSS class names */
    className: PropTypes.string,
};
export default FormErrorDisplay;
